import React from "react";
import { PageHero } from "./PageHero";
import { routes } from "../../utils/utils.routes";

export const BreadcrumpComponent: React.FC<{
  title: React.ReactNode | string;
  subtitle: React.ReactNode | string;
  imageCover: string;
  eyebrow?: string;
}> = ({ title, subtitle, imageCover, eyebrow }) => (
  <PageHero
    imageCover={imageCover}
    eyebrow={eyebrow}
    title={title}
    lead={subtitle}
    tall
    breadcrumbs={[
      { label: "Accueil", href: routes.HOME },
      { label: typeof title === "string" ? title : "Page" },
    ]}
  />
);
